import { ArrowsIcon } from "assets/icons";
import { If } from "components";
import { useBoolean, useOnClickOutside } from "hooks";
import { useRef } from "react";
import { Avatar, Icon } from "ui";

import { useProfile } from "../../apis";
import { AdminRoles } from "../../constants/adminRoles";
import LogoutModal from "../LogoutModal";
import placeholderAvatar from "./placeholderAvatar.png";

import styles from "./ProfileBlock.module.scss";

const ProfileBlock = () => {
  const containerRef = useRef(null);

  const {
    value: isOpenModal,
    setFalse: closeModal,
    toggle: toggleModal
  } = useBoolean(false);

  useOnClickOutside(containerRef, closeModal);

  const { user } = useProfile({ enabled: false });

  return (
    <div ref={containerRef} className={styles.profile} onClick={toggleModal}>
      <div className={styles.profile__avatar}>
        <Avatar
          image={user.image}
          Placeholder={(props) => {
            return <img src={placeholderAvatar} alt="Avatar" {...props} />;
          }}
          dimensions={{ width: 40, height: 40, borderRadius: "100px" }}
        />
      </div>

      <div className={styles.profile__info}>
        <p className={styles.profile__info__name}>{user.email}</p>
        <p className={styles.profile__info__role}>{AdminRoles[user.role]}</p>
      </div>

      <Icon as={ArrowsIcon} boxSize={16} color="#090914" />

      <If condition={isOpenModal}>
        <LogoutModal />
      </If>
    </div>
  );
};

export default ProfileBlock;
